import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ProductRecentAction } from '../../../../../core/api/api.entities';
import { DashboardService } from '../../../../../core/services/dashboard.service';
import { ProductActionType } from '../../../../../shared/enums/product-action-type.enum';
import { formatStockAmount } from '../../../../../shared/utils/formatters.utils';
import { DashboardActionDialogComponent } from '../dashboard-action-dialog/dashboard-action-dialog.component';

@Component({
  selector: 'app-dashboard-recent-actions',
  templateUrl: './dashboard-recent-actions.component.html',
  styleUrl: './dashboard-recent-actions.component.scss',
})
export class DashboardRecentActionsComponent extends DashboardActionDialogComponent {
  columns: string[] = ['date', 'type', 'stockItem.amount', 'purchase.price', 'undo'];

  constructor(service: DashboardService) {
    super(service);
  }

  formatAmount(row: ProductRecentAction): string {
    const product = this.service.product;
    if (product) {
      return formatStockAmount(
        row.stockItem.amount,
        row.type === ProductActionType.Purchase ? product.quantityUnitPurchase : product.quantityUnitStock
      );
    } else return row.stockItem.amount.toString();
  }

  get isSubmitting(): boolean {
    return this.service.state.isSubmitting;
  }

  get stockItems(): MatTableDataSource<ProductRecentAction> {
    return new MatTableDataSource(this.service.product?.recentActions || []);
  }

  undoRecentAction(stockItemId: number, type: ProductActionType): void {
    this.service.undoRecentAction(stockItemId, type).subscribe();
  }
}
